import { Home, BarChart3, Library } from 'lucide-react';
import type { Tutee } from '../../types/tuition';

export type FlashcardsTab = 'home' | 'progress' | 'mycards';

interface FlashcardsNavTabsProps {
  tutee: Tutee;
  active: FlashcardsTab;
  onChange: (tab: FlashcardsTab) => void;
  showMyCards?: boolean;
}

const TABS: { id: FlashcardsTab; label: string; icon: typeof Home }[] = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'progress', label: 'Progress', icon: BarChart3 },
  { id: 'mycards', label: 'My Cards', icon: Library },
];

const FlashcardsNavTabs = ({ tutee, active, onChange, showMyCards = true }: FlashcardsNavTabsProps) => {
  const tabs = showMyCards ? TABS : TABS.filter((t) => t.id !== 'mycards');

  return (
    <div className="flex flex-wrap gap-2 mb-6 p-1.5 bg-white/60 backdrop-blur rounded-2xl border border-white/60 shadow-sm">
      {tabs.map(({ id, label, icon: Icon }) => {
        const isActive = active === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            className={`flex-1 min-w-[5.5rem] flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-bold transition-all active:scale-[0.98] ${
              isActive
                ? `bg-gradient-to-r ${tutee.colorScheme.gradient} text-white shadow-md`
                : 'text-gray-600 hover:bg-white/80'
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default FlashcardsNavTabs;
